module.exports = __webpack_public_path__ + "img/新官網首頁圖-2(直).5efbe982.png";